import http from '@/shared/config/httpService';

import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { ISummaryReport } from '@/shared/model/summary-report.model';
import { IFooter } from '@/shared/model/footer.model';
import { ICustomTextField } from '@/shared/model/custom-text-field.model';
import { TextFieldType } from '@/shared/model/text-field-setting.model';

const summaryReportApiUrl = 'api/summary-reports';
const summaryReportAdminApiUrl = 'api/admin/summary-reports';

export default class ReportService {
  /**
   * create a new summary report
   * @param report summary report to create
   */
  public async createReport(report: ISummaryReport): Promise<ISummaryReport> {
    const res = await http.post(summaryReportApiUrl, report);
    return res.data;
  }

  /**
   * retrieve all summary reports
   * @param paginationQuery pagination query
   */
  public async retrieveAllSummaryReportsPreview(paginationQuery?: any): Promise<any> {
    return http.get(
      summaryReportApiUrl + `/list-preview?${buildPaginationQueryOpts(paginationQuery)}`
    );
  }

  /**
   * delete summary report with given id
   * @param id id of summary report to delete
   */
  public async deleteSummaryReport(id: number): Promise<any> {
    return http.delete(`${summaryReportAdminApiUrl}/${id}`);
  }

  /**
   * retrieve summary report with given id
   * @param id id of summary report to retrieve
   */
  public async find(id: number): Promise<ISummaryReport> {
    return (await http.get(`${summaryReportApiUrl}/${id}`)).data;
  }

  /**
   * downloads the pdf file from cca
   * @param {number} id - id of the summary report
   * @param {string} frontendUrl - url of the frontend
   * @return {Promise<AxiosResponse<any>>} - response with the pdf file
   */
  public async downloadPDFFromCCA(id: number, frontendUrl: string): Promise<any> {
    //add frontendUrl to the request as query parameter
    const dto = {
      frontendUrl: frontendUrl,
    };

    return await http.post(`${summaryReportApiUrl}/${id}/pdf/download`, dto, {
      responseType: 'blob',
    });
  }

  /**
   * Store the summary report in CCA
   * @param {number} id - id of the summary report
   * @param {string} frontendUrl - url of the frontend
   * @return {Promise<void>}
   */
  async storeInCCA(id: number, frontendUrl: string): Promise<void> {
    const dto = {
      frontendUrl: frontendUrl,
    };
    return await http.post(`${summaryReportApiUrl}/${id}/pdf`, dto);
  }

  /**
   * temporary method to rebuild editor info from footer information
   * //remove after editor info endpoint is done
   * @private
   */
  public rebuildEditorInfoFromFooter(
    footer: IFooter | null,
    textfields: ICustomTextField[]
  ): ICustomTextField | null {
    //get footer

    if (!footer) {
      console.warn('No footer found');
      return;
    }

    //get editor text setting
    const editorTextSetting = textfields.find(item => item.type === TextFieldType.EDITOR);
    if (!editorTextSetting) {
      console.warn('No editor text setting found');
      return;
    }

    //update editor text setting

    let email = footer.officeEmail;
    if (email) {
      email += '\n';
    } else {
      email = '';
    }
    let phone = footer.officePhone;
    if (phone) {
      phone += '\n';
    } else {
      phone = '';
    }

    editorTextSetting.value = editorTextSetting.value + phone + email;

    console.log('rebuild editor info from footer', editorTextSetting);
    return editorTextSetting;
  }
}
